import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ContratistaService } from 'src/app/services/contratista.service';
import { LoginService } from 'src/app/services/login.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { MatDialog } from '@angular/material/dialog';
import { LicenciaService } from 'src/app/services/licencia.service';
import { PopupLicenciaCaducadaComponent} from 'src/app/components/portal-contratista/licencias/popup-licencia-caducada/popup-licencia-caducada.component';
import moment from 'moment';

@Component({
  selector: 'app-general-portal-contratista',
  templateUrl: './general-portal-contratista.component.html',
  styleUrls: ['./general-portal-contratista.component.scss']
})
export class GeneralPortalContratistaComponent implements OnInit {
  loggedUser:any
  contratista:any
  licencias: any
  fechaRenovar: any
  licenciasCaducadas: any

  constructor(private contratistaService: ContratistaService, private loginService:LoginService,
   private apollo: Apollo, private userService:UsuariosService,
    public dialog: MatDialog, private licenciaService:LicenciaService) { 
    this.loggedUser = loginService.getUserData()
    this.fechaRenovar = moment().subtract('days', 30).format()
  }

  ngOnInit(): void {
    this.getContratistaById()
    this.getUserLogged()
    this.getLicenciasByContratista()
 
  }

  getContratistaById(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistaById(),
      variables: {
        "id": this.loggedUser.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
      /*  this.contratista = data.contratista;
        console.log(data) */
      })
  }

  getUserLogged(){
    this.apollo.watchQuery<any>({
      query: this.userService.getUsuariosById(),
      variables: {
        "id": this.loggedUser.id,
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loginService.setUserData(data.user)
       /*  this.loginService.setUserData(data.user) */

      })
  }

  getLicenciasByContratista() {
    this.apollo.watchQuery<any>({
      query: this.licenciaService.getLicenciasByContratista(),
      variables: {
        "id": this.loggedUser.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.licencias = data.contratista.licencias
        console.log(this.licencias)
        this.licenciasCaducadas= this.licencias.filter((licencia: any)=> licencia.fechaCaducidad <= this.fechaRenovar)
        console.log(this.licenciasCaducadas)
        if (this.licenciasCaducadas.length > 0) {
         this.dialog.open(PopupLicenciaCaducadaComponent)      
        } 
      })
  }


}
